/**
 * The guide's one stored preference: whether a floating "?" is shown over the page.
 *
 * Off by default. A floating button in the bottom-right corner sits exactly where the tables
 * keep their pagination and row actions; the docked "?" in the top bar is always reachable and
 * covers nothing, so the floating one is an opt-in.
 *
 * localStorage rather than a jotai atom or a UAD app setting on purpose: this is one component's
 * own chrome, not app state, and `help/` stays importable with no providers around it. The
 * guide's language is not stored here — it follows the language picked in the app's settings.
 */
const STORAGE_PREFIX = "hbh.help";

export const HELP_FLOATING_KEY = `${STORAGE_PREFIX}.floating-button`;

export const readFloatingPref = (): boolean => {
  try {
    return window.localStorage.getItem(HELP_FLOATING_KEY) === "on";
  } catch {
    // Storage can throw outright (private mode, blocked site data) — fall back to the default.
    return false;
  }
};

export const writeFloatingPref = (on: boolean): void => {
  try {
    window.localStorage.setItem(HELP_FLOATING_KEY, on ? "on" : "off");
  } catch {
    // Best-effort: the choice then simply lasts for this session.
  }
};
